<template>
  <div style="background: white;margin-top: 20px;padding: 20px 0 20px 0;">
    <el-row>
      <el-col :span="24">
        <div class="prodect">
          按链接申报
        </div>
        <div style="margin-left: 20px;margin-top: 10px;">
          <span v-for="(item,index) in orderProduct" :key='index' style="width: 175px;display: inline-block;">
            <el-checkbox :label="item.fieldname" style="margin-bottom: 10px;width: 100px;"
              v-model="basicField[index]" :disabled="jbDisabled == 1 || item.fieldname == '最终到手价' || item.fieldname == '预计均价'" @change="checkboxEmpty(item.fieldname,index,item.id,item.fieldRequired)">
            </el-checkbox>
            <el-tooltip class="item" effect="dark" content="系统用于匹配活动是否违规时使用" placement="top-start">
             <i class="el-icon-warning-outline" v-show="item.fieldname == '最终到手价' || item.fieldname == '预计均价'"></i>
           </el-tooltip>
          </span>
        </div>
      </el-col>
    </el-row>
  </div>
</template>

<script>
  import axios from "axios";
  export default {
    name: "setTheField",
    data() {
      return {
        jbDisabled: 1,
        basicField: [],
        orderProduct: [],
        ids: [],
        treeData: [],
      }
    },
    mounted() {
      this.getListByCampaignsetting()
    },
    methods: {
      // 是否disabled
      wlShow(e) {
        if(e == 1) {
          this.jbDisabled = 2
        } else {
          this.jbDisabled = 1
        }
      },
      //确定保存
      saveSort() {
        this.ids = [];
        for (var i = 0; i < this.treeData.length; i++) {
          this.ids.push(this.treeData[i].id)
        }
        let params={
          ids: this.ids.join(','),
          module: 'CAMPAIGNLINK',
          type: '1',
        }
        fetch({
          url: "hcm/hcmCustomModel/saveSortCampaign",
          method: "post",
          params: params,
          noFormat: true,
          responseType: "text"
        }).then(result => {
          let res = JSON.parse(result);
          let {data}=res
          if(res.status == '10000'){
            this.$message({
              message: '设置成功',
              type: 'success'
            });
            this.ids = [];
            this.getListByCampaignsetting()
            this.jbDisabled = 1
          } else {
            this.$message.error(res.message);
          }
        })
      },
      checkboxEmpty(e,f,h,g) {
        if (this.basicField[f] == false) {
          for (var i = 0; i < this.treeData.length; i++) {
            if (this.treeData[i].label == e){
              this.treeData.splice(i, 1);
            }
          }
        } else {
          this.treeData.push(
            {
              id: h,
              label: e,
              fieldRequired: g,
              index: f,
            }
          );
        }
      },
      //获取动态表格
      getListByCampaignsetting() {
        let params = {
          module: 'CAMPAIGNLINK',
        }
        fetch({
          url: "hcm/hcmCustomModel/getListByCampaignsetting",
          method: "get",
          noFormat: true,
          params: params,
          responseType: "text"
        }).then(result => {
          let res = JSON.parse(result);
          let {data}=res
          if(res.status == '10000'){
            this.treeData = [];
            this.orderProduct = [];
            this.basicField = [];
            this.orderProduct = data.campaign.data.concat(data.price.data);
            console.log(this.orderProduct)
            for (var i = 0; i < this.orderProduct.length; i++) {
              if (this.orderProduct[i].campaigntype == 0) {
                this.basicField.push(true)
                this.treeData.push({
                  id: this.orderProduct[i].id,
                  label: this.orderProduct[i].fieldname,
                  fieldRequired: this.orderProduct[i].campaigntype,
                  index: i
                });
              } else {
                this.basicField.push(false)
              }
            }
          }
        })
      },

    }
  }
</script>
<style scoped lang="scss">
  .el-button--TheCustom {
    color: #666;
    border-color: #D9D9D9;
    background-color: #fff;
  }
  .el-button--TheCustom:hover  {
    color: #666;
    border-color: #ded2b8;
    background-color: #faf9f5;
  }
  .page {
    padding: 20px;
    margin: 10px 20px 20px 20px;
    background-color: white;
    min-height: 600px;
  }

  .prodect {
    height: 40px;
    line-height: 40px;
    padding-left: 20px;
  }
</style>
<style lang="scss">
#activityChecking {
  .el-table__empty-text{
    padding-top: 100px;
    background: url("../../../assets/img/other/nodata.svg") no-repeat;
    background-position: center 66px;
  }
  .el-table th {
    background-color: #f3f7ff !important;
  }
  .el-table thead {
    color: #333333;
    font-weight: 500;
  }
  .el-dialog__title {
    font-size: 14px;
  }
  .el-button--TheCustom {
    color: #666;
    border-color: #D9D9D9;
    background-color: #fff;
  }
  .el-button--TheCustom:hover  {
    color: #666;
    border-color: #ded2b8;
    background-color: #faf9f5;
  }
  .el-button--primary2 {
    color: #FFF;
    background-color: #bda571;
    border-color: #bda571;
  }
  .el-button--primary2:hover {
    color: #FFF;
    background-color: #c0ae8a;
    border-color: #c0ae8a;
  }
  #dialog {
    .el-dialog__header {
      padding: 20px 20px 10px;
      border-bottom: 1px solid #d9d9d9;
    }
    .el-button--primary2 {
      color: #FFF;
      background-color: #bda571;
      border-color: #bda571;
    }
    .el-button--primary2:hover {
      color: #FFF;
      background-color: #c0ae8a;
      border-color: #c0ae8a;
    }
  }
  .w-e-menu{
    z-index: 2 !important;
  }
  .el-button+.el-button {
    margin-left: 1px;
  }
}
</style>
